import { render, staticRenderFns } from "./SpecialCategory.vue?vue&type=template&id=520aaca6&scoped=true&"
import script from "./SpecialCategory.vue?vue&type=script&lang=js&"
export * from "./SpecialCategory.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCategory.vue?vue&type=style&index=0&id=520aaca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520aaca6",
  null
  
)

export default component.exports